/* eslint-disable no-undef */

import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { getHeaders } from "../../utility/getHeader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import CardComponent from "../../components/cards/CardComponent";

import Header from "../../components/Header";
import Layout from "../../layout/Layout";
import { format } from "date-fns";

import { TextfieldwithLabel } from "../../components/Buttons/Textfield";
import { SubmitButton } from "../../components/Buttons/Textfield";
import fetchData from "../../functions/fetchData";

export default function Customers() {
  let currentDate = format(new Date(), "yyyy-MM-dd");
  //  const headers = { Authorization: authheader().access_token };
  const [data, setData] = useState([]);
  const [errors, setErrors] = useState({});
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [editFormData, setEditFormData] = useState({
    name: "",
    contact: "",
    email: "",
    taxid: "",
    address: "",
  });
  const [formdata, setFormData] = useState({
    name: "",
    contact: "",
    email: "",
    nametaxid: "",
    address: "",
    opening_balance: "",
  });
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    // alert(e.target);
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  
  const handleEditInputChange = (e) => {
    const { name, value } = e.target;
    setEditFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    console.log('Form Data before submission:', formdata); // Debug log to check form data

    // Show loading toast
    const loadingToast = toast.loading("Adding customer...");

    try {
      // First, save the customer
      const customerResponse = await axios.post(
        "/insertdata/customers",
        {
          name: formdata.name,
          contact: formdata.contact,
          email: formdata.email,
          taxid: formdata.taxid,
          address: formdata.address,
        },
        getHeaders()
      );

      console.log('Customer Response:', customerResponse.data); // Debug log

      // If opening balance is provided and greater than 0, create ledger entry
      const openingBalance = parseFloat(formdata.opening_balance) || 0;
      console.log('Opening Balance:', openingBalance); // Debug log
      
      if (openingBalance > 0) {
        // Based on your backend controller, the response should have 'id' field
        const customerId = customerResponse.data?.id;
        
        console.log('Customer ID for ledger:', customerId); // Debug log
        console.log('Full customer response:', customerResponse.data); // Debug log
        
        if (customerId) {
          const transactionId = `OPENING_${customerId}_${Date.now()}`;
          
          console.log('Creating ledger entry with:', { // Debug log
            transaction_id: transactionId,
            account_id: customerId,
            debit_amount: openingBalance
          });
          
          await axios.post(
            "/insertdata/ledger_entries",
            {
              transaction_id: transactionId,
              date: new Date().toISOString(),
              account_type: "Account Recievable",
              account_id: customerId,
              description: `Opening Balance for Customer: ${formdata.name}`,
              debit_amount: openingBalance,
              credit_amount: 0.00,
              reference_id: customerId
            },
            getHeaders()
          );
          console.log('✅ Ledger entry created successfully'); // Debug log
        } else {
          console.error('Customer ID not found in response:', customerResponse.data);
          toast.warning('Customer saved but opening balance could not be recorded - Customer ID not found');
        }
      }

      // Fetch the updated data after successful submission
      await fetchData("customers", setData, "id", {});

      toast.success(`🎉 Customer "${formdata.name}" added successfully!${openingBalance > 0 ? ` Opening balance of ฿${openingBalance} recorded.` : ''}`);
      toast.dismiss(loadingToast);
      setFormData([]);
    } catch (err) {
      toast.dismiss(loadingToast);
      toast.error(`❌ Failed to add customer: ${err.response?.data?.message || err.message}`);
      console.error(err.message);
    }

    // Clear form data and errors
    setFormData({
      name: "",
      contact: "",
      email: "",
      taxid: "",
      address: "",
      opening_balance: "",
    });

    setErrors({});
  };

  // Handle edit button click
  const handleEdit = (customer) => {
    setSelectedCustomer(customer);
    setEditFormData({
      name: customer.name || "",
      contact: customer.contact || "",
      email: customer.email || "",
      taxid: customer.taxid || "",
      address: customer.address || "",
    });
    setShowEditModal(true);
  };

  // Handle update submit
  const handleUpdateSubmit = async (e) => {
    e.preventDefault();
    
    if (!selectedCustomer) return;
    
    try {
      await axios.put(
        `/updatecommondata/customers/id/${selectedCustomer.id}`,
        {
          name: editFormData.name,
          contact: editFormData.contact,
          email: editFormData.email,
          taxid: editFormData.taxid,
          address: editFormData.address,
        },
        getHeaders()
      );

      // Fetch the updated data
      await fetchData("customers", setData, "id", {});
      
      toast.success(`✅ Customer "${editFormData.name}" updated successfully!`);
      setShowEditModal(false);
      setSelectedCustomer(null);
      setEditFormData({
        name: "",
        contact: "",
        email: "",
        taxid: "",
        address: "",
      });
    } catch (err) {
      toast.error(`❌ Failed to update customer: ${err.response?.data?.message || err.message}`);
      console.error(err.message);
    }
  };

  // Handle delete
  const handleDelete = async (customerId, customerName) => {
    if (window.confirm(`Are you sure you want to delete customer "${customerName}"?`)) {
      try {
        await axios.delete(
          `/deletebyid/customers/id/${customerId}`,
          getHeaders()
        );
        
        // Refresh data
        await fetchData("customers", setData, "id", {});
        toast.success(`🗑️ Customer "${customerName}" deleted successfully!`);
      } catch (err) {
        toast.error(`❌ Failed to delete customer: ${err.response?.data?.message || err.message}`);
        console.error(err.message);
      }
    }
  };

  useEffect(() => {
    const fetchAndSetData = async () => {
      try {
        await fetchData("customers", setData, "id", {});
      } catch (error) {
        console.error("Error in useEffect:", error);
      }
    };

    fetchAndSetData();
  }, []);
  return (
    <>
      <Layout>
        <Header title="Add New Customer" />
        <ToastContainer />
        <div className="row">
          <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
            <CardComponent
              title="Add Customer for new Ledger"
              headerColor="darkblue"
              pull="left"
              bodyClass="panel-body"
            >
              <div class="row">
                <div class="col-md-12">
                  <form onSubmit={handleSubmit}>
                    <div class="panel panel-default card-view">
                      <TextfieldwithLabel
                        id="name"
                        onChange={(e) => handleInputChange(e)}
                        value={formdata.name}
                        type="text"
                        name="name"
                        lable="Customer Name"
                      />
                      <TextfieldwithLabel
                        id="contact"
                        onChange={(e) => handleInputChange(e)}
                        value={formdata.contact}
                        type="number"
                        name="contact"
                        lable="Contact"
                      />
                      <TextfieldwithLabel
                        id="email"
                        onChange={(e) => handleInputChange(e)}
                        value={formdata.email}
                        type="text"
                        name="email"
                        lable="Email ID"
                      />
                      <TextfieldwithLabel
                        id="taxid"
                        onChange={(e) => handleInputChange(e)}
                        value={formdata.taxid}
                        type="text"
                        name="taxid"
                        lable="Tax ID(if Any)"
                      />
                      <TextfieldwithLabel
                        id="address"
                        onChange={(e) => handleInputChange(e)}
                        value={formdata.address}
                        type="text"
                        name="address"
                        lable="Address"
                      />
                      <TextfieldwithLabel
                        id="opening_balance"
                        onChange={(e) => handleInputChange(e)}
                        value={formdata.opening_balance}
                        type="number"
                        step="0.01"
                        name="opening_balance"
                        lable="Opening Balance (Optional)"
                      />
                    </div>

                    <div className="form-group">
                      <label className="control-label mb-12"></label>
                      <SubmitButton
                        type="submit"
                        name="Save"
                        cls="btn btn-darkblue btn-anim"
                      />
                    </div>
                  </form>
                </div>
              </div>
            </CardComponent>
          </div>
          {/* <ExportDataTable
                                tableId="tableid"
                                tableData={data} /> */}
          <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12" id="tableid">
            <CardComponent
              title="Customer List"
              headerColor="lightblue"
              pull="left"
              bodyClass="panel-body"
            >
              {data.length === 0 ? (
                <div className="text-center p-4">
                  <i className="fa fa-users fa-3x text-muted mb-3"></i>
                  <p className="text-muted">No customers available</p>
                </div>
              ) : (
                <div className="table-responsive">
                  <table className="table table-striped table-hover">
                    <thead className="table-dark">
                      <tr>
                        <th scope="col">#</th>
                        <th scope="col">
                          <i className="fa fa-user me-2"></i>Name
                        </th>
                        <th scope="col">
                          <i className="fa fa-phone me-2"></i>Contact
                        </th>
                        <th scope="col">
                          <i className="fa fa-envelope me-2"></i>Email
                        </th>
                        <th scope="col">
                          <i className="fa fa-id-card me-2"></i>Tax ID
                        </th>
                        <th scope="col">
                          <i className="fa fa-map-marker-alt me-2"></i>Address
                        </th>
                        <th scope="col" className="text-center">
                          <i className="fa fa-cogs me-2"></i>Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.map((customer, index) => (
                        <tr key={customer.id}>
                          <th scope="row" className="text-muted">
                            {index + 1}
                          </th>
                          <td className="fw-bold text-primary">
                            {customer.name}
                            <br />
                            <small className="text-muted">ID: #{customer.id}</small>
                          </td>
                          <td>
                            {customer.contact ? (
                              <span className="text-dark">{customer.contact}</span>
                            ) : (
                              <span className="text-muted">-</span>
                            )}
                          </td>
                          <td>
                            {customer.email ? (
                              <span className="text-dark">{customer.email}</span>
                            ) : (
                              <span className="text-muted">-</span>
                            )}
                          </td>
                          <td>
                            {customer.taxid ? (
                              <span className="text-dark">{customer.taxid}</span>
                            ) : (
                              <span className="text-muted">-</span>
                            )}
                          </td>
                          <td>
                            {customer.address ? (
                              <span className="text-dark">
                                {customer.address.length > 30 
                                  ? `${customer.address.substring(0, 30)}...` 
                                  : customer.address}
                              </span>
                            ) : (
                              <span className="text-muted">-</span>
                            )}
                          </td>
                          <td className="text-center">
                            <div className="btn-group" role="group">
                              <button
                                className="btn btn-outline-primary btn-sm"
                                onClick={() => handleEdit(customer)}
                                title="Edit Customer"
                              >
                                <i className="fa fa-edit"></i>
                              </button>
                              <button
                                className="btn btn-outline-danger btn-sm"
                                onClick={() => handleDelete(customer.id, customer.name)}
                                title="Delete Customer"
                              >
                                <i className="fa fa-trash"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  
                  {/* Table Summary */}
                  <div className="d-flex justify-content-between align-items-center mt-3 p-3 bg-light rounded">
                    <div>
                      <small className="text-muted">
                        <i className="fa fa-info-circle me-1"></i>
                        Showing {data.length} customer{data.length !== 1 ? 's' : ''}
                      </small>
                    </div>
                    <div>
                      <small className="text-muted">
                        <i className="fa fa-calendar me-1"></i>
                        Last updated: {new Date().toLocaleDateString()}
                      </small>
                    </div>
                  </div>
                </div>
              )}
            </CardComponent>
          </div>
        </div>
        
        {/* Edit Customer Modal */}
        {showEditModal && (
          <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Edit Customer</h5>
                  <button 
                    type="button" 
                    className="btn-close" 
                    onClick={() => setShowEditModal(false)}
                  ></button>
                </div>
                <div className="modal-body">
                  <form onSubmit={handleUpdateSubmit}>
                    <div className="row">
                      <div className="col-md-6">
                        <TextfieldwithLabel
                          id="edit_name"
                          onChange={handleEditInputChange}
                          value={editFormData.name}
                          type="text"
                          name="name"
                          lable="Customer Name"
                        />
                      </div>
                      <div className="col-md-6">
                        <TextfieldwithLabel
                          id="edit_contact"
                          onChange={handleEditInputChange}
                          value={editFormData.contact}
                          type="number"
                          name="contact"
                          lable="Contact"
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <TextfieldwithLabel
                          id="edit_email"
                          onChange={handleEditInputChange}
                          value={editFormData.email}
                          type="email"
                          name="email"
                          lable="Email ID"
                        />
                      </div>
                      <div className="col-md-6">
                        <TextfieldwithLabel
                          id="edit_taxid"
                          onChange={handleEditInputChange}
                          value={editFormData.taxid}
                          type="text"
                          name="taxid"
                          lable="Tax ID (if Any)"
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <TextfieldwithLabel
                          id="edit_address"
                          onChange={handleEditInputChange}
                          value={editFormData.address}
                          type="text"
                          name="address"
                          lable="Address"
                        />
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button 
                        type="button" 
                        className="btn btn-secondary" 
                        onClick={() => setShowEditModal(false)}
                      >
                        Cancel
                      </button>
                      <button type="submit" className="btn btn-primary">
                        Update Customer
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        )}
      </Layout>
    </>
  );
}
